export function objectToQuery (params: any) {    
    if (!params) return '';
    if (Object.keys(params).length === 0 && params.constructor === Object) return '';
    return Object.keys(params).map((key: string): string => key + '=' + params[key]).join('&');
}